var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.86914C7.15739 3.86914 5.65829 5.36824 5.65829 7.21085C5.65829 9.05346 7.15739 10.5526 9 10.5526C10.8426 10.5526 12.3417 9.05346 12.3417 7.21085C12.3417 5.36824 10.8426 3.86914 9 3.86914ZM9 9.14553C7.93322 9.14553 7.06532 8.27763 7.06532 7.21085C7.06532 6.14407 7.93322 5.27616 9 5.27616C10.0668 5.27616 10.9347 6.14407 10.9347 7.21085C10.9347 8.27763 10.0668 9.14553 9 9.14553Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 0C5.02378 0 1.78891 3.2349 1.78891 7.21107V7.41041C1.78891 9.42135 2.94182 11.7647 5.21573 14.3753C6.86414 16.2679 8.48951 17.5875 8.55786 17.6427L8.99998 18L9.44211 17.6428C9.51049 17.5875 11.1359 16.2679 12.7842 14.3754C15.0581 11.7647 16.2111 9.42138 16.2111 7.41045V7.21111C16.2111 3.2349 12.9762 0 8.99998 0ZM14.804 7.41045C14.804 10.8088 10.4253 14.9226 8.99998 16.1715C7.57429 14.9222 3.19593 10.8086 3.19593 7.41045V7.21111C3.19593 4.01077 5.79964 1.40706 8.99998 1.40706C12.2003 1.40706 14.804 4.01077 14.804 7.21111V7.41045Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.c31d8a7443ca9134d9ff8e213540a645.svg";
export { ForwardRef as ReactComponent };